'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const utils_headingLevelContext_HeadingLevelContext = require('../../../utils/heading-level-context/HeadingLevelContext.cjs.js');
const utils_clamp = require('../../../utils/clamp.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("Heading", {
  root: react.css`
    ${styleMixins_reset.baseReset};
    display: block;
  `
});
const Heading = ({ children, className, style }) => {
  const { level } = utils_headingLevelContext_HeadingLevelContext.useHeadingLevel();
  const headingLevel = utils_clamp.clamp(level, 1, 6);
  const Tag = `h${headingLevel}`;
  return react.jsx(Tag, { css: Styles.root, className, "data-zds": true, style }, children);
};

exports.Heading = Heading;
//# sourceMappingURL=Heading.cjs.js.map
